export const initialValues = {
    user_name_tx: "",
    status: "",
    startincident_dt: "",
    endincident_dt: "",
    incidentname_tx: "",
    description_tx: "",
    incident_id: "",
    device_cd: "",
    startscore_nr: "",
    endscore_nr: "",
}